import axios from 'axios';

const WORDPRESS_API_URL = 'https://aupiho.com/wp-json/wp/v2';

export interface RankMathSEO {
  title?: string;
  description?: string;
  robots?: string[];
  canonical?: string;
  og_title?: string;
  og_description?: string;
  og_image?: string;
  twitter_title?: string;
  twitter_description?: string;
  twitter_image?: string;
}

export interface WordPressPost {
  id: number;
  date: string;
  title: {
    rendered: string;
  };
  content: {
    rendered: string;
  };
  excerpt: {
    rendered: string;
  };
  slug: string;
  featured_media: number;
  rank_math?: RankMathSEO;
  yoast_head?: string;
  yoast_head_json?: any;
  _embedded?: {
    'wp:featuredmedia'?: Array<{
      source_url: string;
      alt_text: string;
    }>;
  };
}

export interface PostsQueryParams {
  page?: number;
  per_page?: number;
  search?: string;
  categories?: string;
}

class PostsService {
  async getPosts(params: PostsQueryParams = {}): Promise<{ posts: WordPressPost[]; total: number; totalPages: number }> {
    try {
      const response = await axios.get(`${WORDPRESS_API_URL}/posts`, {
        params: {
          ...params,
          _embed: true, // Pour récupérer les images mises en avant
        },
      });

      return {
        posts: response.data,
        total: parseInt(response.headers['x-wp-total'] || '0'),
        totalPages: parseInt(response.headers['x-wp-totalpages'] || '0'),
      };
    } catch (error) {
      console.error('Error fetching posts:', error);
      return {
        posts: [],
        total: 0,
        totalPages: 0,
      };
    }
  }

  async getPostBySlug(slug: string): Promise<WordPressPost | null> {
    try {
      const response = await axios.get(`${WORDPRESS_API_URL}/posts`, {
        params: {
          slug,
          _embed: true,
        },
      });

      return response.data[0] || null;
    } catch (error) {
      console.error('Error fetching post:', error);
      return null;
    }
  }

  getFeaturedImage(post: WordPressPost): string | null {
    return post._embedded?.['wp:featuredmedia']?.[0]?.source_url || null;
  }

  getExcerpt(post: WordPressPost): string {
    const div = document.createElement('div');
    div.innerHTML = post.excerpt.rendered;
    return div.textContent || div.innerText || '';
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }
}

export const postsService = new PostsService();

